query PurchaseOrderSearch(
  $isLinkSearch: Boolean
  $searchRequest: SearchRequestInput
  $first: Int
  $filter: PurchaseOrderFilter
  $orderBy: [PurchaseOrdersOrderBy!]
  $after: Cursor
  $filterSupplierId: UUID
  $filterMultiStatusTypes: [Int]
  $isSigningSearch: Boolean
  $isHistorySearch: Boolean
  $isSearchAllData: Boolean
) {
  purchaseOrderSearch(
    isLinkSearch: $isLinkSearch
    searchRequest: $searchRequest
    first: $first
    filter: $filter
    orderBy: $orderBy
    after: $after
    filterSupplierId: $filterSupplierId
    filterMultiStatusTypes: $filterMultiStatusTypes
    isSigningSearch: $isSigningSearch
    isHistorySearch: $isHistorySearch
    isSearchAllData: $isSearchAllData
  ) {
    nodes {
      __typename
      id
      _accountingExportCycleId
      _accountingExportDate
      userExport {
        name
      }
      _urgencyLevel
      _isUpdatable
      sortSupplierName
      _isDeletable
      purchaseOrderType {
        purchaseOrderType
      }
      _appliedTotals {
        usedAmount
        remainingAmount
        appliedAmount
        retiredAmount
        overageAmount
      }
      purchaseOrderNumber
      purchaseOrderDate
      sortSupplierName
      description

      department {
        name
        id
      }
      businessUnit {
        id
        name
      }
      currency {
        id
        isoCode
        currencySymbol
      }
      controlTotalAmount
      _statusTypeId
      statusType {
        statusType
        approvalState
        _transactionIconStatus
      }
      _rowTimestamp
      _referenceItemTypes
      _accountingStampTransactionReference
      _createdByUserName
      _createdDate
      _baseCurrencyAmount
      _spotCurrencyAmount
      _isStagedApprovalRequest
      _pendingApprovers
      _isAccountingEntryStampedComplete
      _isAccountingEntry
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
